import { createContext, useContext } from 'react'

export type AiJobType = 'screening' | 'enrichment'

export interface AiJob {
  id: string
  type: AiJobType
  inProgressCount: number
  providerIds?: number[]
  startedAt: number
}

export interface CompletedJob {
  id: string
  type: AiJobType
  completedAt: number
  enrichedProviderIds?: number[]
}

export interface AiJobsContextProps {
  jobs: AiJob[]
  completedJobs: CompletedJob[]
  isAnyJobRunning: boolean
  addJob: (job: Omit<AiJob, 'id' | 'startedAt'>) => void
  markJobAsViewed: (jobId: string) => void
  clearCompletedJobs: () => void
}

const AiJobsContext = createContext<AiJobsContextProps>({
  jobs: [],
  completedJobs: [],
  isAnyJobRunning: false,
  addJob: () => undefined,
  markJobAsViewed: () => undefined,
  clearCompletedJobs: () => undefined,
})

export const useAiJobs = (): AiJobsContextProps => {
  return useContext(AiJobsContext)
}

export default AiJobsContext
